import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ProgressTimeIconSvg from '../../assets/icons/icon-progress-time.svg?react';

type RegistrationProgressProps = {
  progressPercent: number;
  progressPercentLabel: string;
  progressEtaTranslationKey: string;
};

const ProgressContainer = styled.section.attrs({
  'data-ui': 'registration-progress',
})`
  width: ${({ theme }) => theme.scale.px(356)};
  margin: 0 auto;
  display: grid;
  gap: ${({ theme }) => theme.scale.px(4)};
`;

const MetricsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const EtaCluster = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.scale.px(4)};
`;

const TimeIcon = styled(ProgressTimeIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(7)};
  height: ${({ theme }) => theme.scale.px(11)};
  display: block;
  color: #62605a;

  & path {
    stroke: currentColor;
  }
`;

const MetricLabel = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(10)};
  font-weight: 500;
  line-height: ${({ theme }) => theme.scale.px(12)};
  color: #62605a;
`;

const Track = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.scale.px(6)};
  border-radius: ${({ theme }) => theme.scale.px(3)};
  background: #ebece8;
`;

const Fill = styled.div<{ $progressPercent: number }>`
  width: ${({ $progressPercent }) => `${$progressPercent}%`};
  height: 100%;
  border-radius: inherit;
  background: #62605a;
  transition: width 320ms ease;
`;

export function RegistrationProgress({
  progressPercent,
  progressPercentLabel,
  progressEtaTranslationKey,
}: RegistrationProgressProps) {
  const { t } = useTranslation();

  return (
    <ProgressContainer>
      <MetricsRow>
        <EtaCluster>
          <TimeIcon />
          <MetricLabel>{t(progressEtaTranslationKey)}</MetricLabel>
        </EtaCluster>
        <MetricLabel>{progressPercentLabel}</MetricLabel>
      </MetricsRow>

      <Track>
        <Fill $progressPercent={progressPercent} />
      </Track>
    </ProgressContainer>
  );
}
